import { connect } from 'react-redux';
import { logoutUser } from '../../actions';
import Logout from './logout';

export default connect(null, { logoutUser: logoutUser.requested })(Logout);
